import Cbdkav1 from "./cbdpik (1).webp";
import Cbdkav2 from "./cbdpik (2).webp";
import Cbdkav3 from "./cbdpik (3).webp";
import Cbdkav4 from "./cbdpik (4).webp";
import Cbdkav5 from "./cbdpik (5).webp";

const cbdpikkav = [Cbdkav1, Cbdkav2, Cbdkav3, Cbdkav4, Cbdkav5];

export default cbdpikkav;
